export default __webpack_public_path__ + "static/media/affliate.26fa5393.svg";